var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"root",staticClass:"magnetic",style:({ transform: `translate3d(${_vm.x}px, ${_vm.y}px, 0)` }),on:{"mousemove":_vm.onMove,"mouseleave":_vm.onLeave}},[_c('div',{staticClass:"magnetic__inner"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }